import uuidV4 from 'uuid/v4';
import api from '../api';
import { DASHBOARD_FEATURE } from '@/features';

export default {
  namespaced: true,
  state: {
    feed: undefined,
  },
  actions: {
    async FETCH_ACTIVITY_FEED({ commit, rootGetters }) {
      if (!rootGetters.features[DASHBOARD_FEATURE]) {
        return;
      }

      const feed = await api.fetchActivityFeed();
      commit('SET_ACTIVITY_FEED', feed || []);
    },
    async PUSH_ACTIVITY({ commit, rootGetters }, { entity, id, title }) {
      if (!rootGetters.features[DASHBOARD_FEATURE]) {
        return;
      }

      if (!entity || !id || !title) {
        return;
      }
      const activity = {
        entity,
        id,
        title,
        date: new Date().toISOString(),
        uuid: uuidV4(),
      };
      commit('APPEND_ACTIVITY_TO_FEED', activity);
      api.postActivity(activity);
    },
  },
  mutations: {
    SET_ACTIVITY_FEED: (state, feed) => {
      state.feed = feed;
    },
    APPEND_ACTIVITY_TO_FEED: (state, activity) => {
      if (Array.isArray(state.feed)) {
        state.feed.push(activity);
      } else {
        state.feed = [activity];
      }
    },
  },
};
